<template>
    <div>
        <div id="ag-grid-demo">
            <vx-card class="p-4 mb-6">
                <div class="flex flex-wrap items-center justify-between mb-10">
                    <div class="flex items-center">
                        <h4 style="margin-left: 10px">Wave Pick Planning</h4>
                    </div>
                    <div class="flex items-center">
                        <vs-button @click="fetch('order')" class="btn mb-4 md:mb-0 mr-1" icon="refresh">Refresh</vs-button>
                        <vs-button class="mb-4 md:mb-0 mr-1" icon="filter_list" @click="filterInit  ">Filter</vs-button>
                        <vs-button @click="createWavepick" icon="add" :disabled="disableAdd">Create Wavepick</vs-button>
                    </div>
                </div>
                <ag-grid-vue
                    :gridOptions="gridOptions"
                    class="ag-theme-material w-100 my-4 ag-grid-table"
                    :columnDefs="columnDefs"
                    :defaultColDef="defaultColDef"
                    :rowData="outbound.data"
                    colResizeDefault="shift"
                    :animateRows="false"
                    :floatingFilter="false"
                    rowSelection="multiple"
                    :rowHeight="35"
                    :headerHeight="35"
                    @selectionChanged="disableAdd = false"
                >
                </ag-grid-vue>
                <p class="text-right"><strong>Showing {{ outbound.from }} to {{ outbound.to }} of {{ outbound.total }} total entries</strong></p>
                <vs-pagination :total="outbound.pages" v-model="outbound.current" :max="7"></vs-pagination>
            </vx-card>
        </div>
        <vs-prompt
            @accept="fetch('order')"
            title="Filter"
            :active.sync="outbound.filter.show">
            <div class="con-exemple-prompt">
                <vs-input v-model="outbound.filter.outbound_reference" class="mb-2 w-full" label="Reference" />
                <label class="vs-input--label">Client ID</label>
                <vs-select
                    class="selectExample mb-2"
                    v-model="outbound.filter.client_id"
                    width="100%"
                    autocomplete
                    @input-change="searchDropdown($event, ddl_client)"
                >
                    <vs-select-item v-for="(item, index) in ddl_client.data" :key="index" :value="item.id" :text="item.client_code"/>
                </vs-select>

                <label class="vs-input--label">Order Type ID</label>
                <vs-select
                    class="selectExample mb-2"
                    v-model="outbound.filter.order_type_id"
                    width="100%"
                    autocomplete
                    @input-change="searchDropdown($event, order_type)"
                >
                    <vs-select-item v-for="(item, index) in order_type.data" :key="index" :value="item.id" :text="item.order_type"/>
                </vs-select>

                <label class="vs-input--label">Req. Del. Date</label>
                <vs-row vs-w="12" vs-justify="space-between" class="mb-2">
                    <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-w="5" style="padding-left: 0">
                        <flat-pickr class="vx-col w-full p-2" v-model="outbound.filter.req_del_date_start" />
                    </vs-col>
                    <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-w="2">To</vs-col>
                    <vs-col vs-type="flex" vs-justify="flex-end" vs-align="center" vs-w="5" style="padding-right: 0">
                        <flat-pickr class="vx-col w-full p-2" v-model="outbound.filter.req_del_date_end" />
                    </vs-col>
                </vs-row>

                <label class="vs-input--label">Origin ID</label>
                <vs-select
                    class="selectExample mb-2"
                    v-model="outbound.filter.origin_id"
                    width="100%"
                    autocomplete
                    @input-change="searchDropdown($event, ddl_origin)"
                >
                    <vs-select-item v-for="(item, index) in ddl_origin.data" :key="index" :value="item.id" :text="item.name"/>
                </vs-select>
                
                <label class="vs-input--label">Destination ID</label>
                <vs-select
                    class="selectExample mb-2"
                    v-model="outbound.filter.destination_id"
                    width="100%"
                    autocomplete
                    @input-change="searchDropdown($event, ddl_destination)"
                >
                    <vs-select-item v-for="(item, index) in ddl_destination.data" :key="index" :value="item.id" :text="item.name"/>
                </vs-select>

                <label class="vs-input--label">Type</label>
                <vs-select
                    class="selectExample mb-2"
                    v-model="outbound.filter.type"
                    width="100%"
                    autocomplete
                >
                    <vs-select-item value="single" text="Single"/>
                    <vs-select-item value="multiple" text="Multiple"/>
                </vs-select>

                <label class="vs-input--label">Order Source ID</label>
                <vs-select
                    class="selectExample mb-2"
                    v-model="outbound.filter.order_source_id"
                    width="100%"
                    autocomplete
                >
                    <vs-select-item v-for="(item, index) in order_source.data" :key="index" :value="item.id" :text="item.name"/>
                </vs-select>

                <label class="vs-input--label">Transporter ID</label>
                <vs-select
                    class="selectExample mb-2"
                    v-model="outbound.filter.transporter_id"
                    width="100%"
                    autocomplete
                    @input-change="searchDropdown($event, transporter)"
                >
                    <vs-select-item v-for="(item, index) in transporter.data" :key="index" :value="item.id" :text="item.transporter_code"/>
                </vs-select>

                <label class="vs-input--label">Service Type ID</label>
                <vs-select
                    class="selectExample mb-2"
                    v-model="outbound.filter.service_type_id"
                    width="100%"
                    autocomplete
                    @input-change="searchDropdown($event, service_type)"
                >
                    <vs-select-item v-for="(item, index) in service_type.data" :key="index" :value="item.id" :text="item.service_type"/>
                </vs-select>
            </div>
        </vs-prompt>

        <vs-prompt
        @accept="saveWavePick()"
        title="Confirm Wave Pick"
        :active.sync="confirm_assign">
            <div class="con-exemple-prompt">
                <label class="vs-input--label">Assign To</label>
                <vs-select
                    class="selectExample"
                    v-model="picker_id"
                    width="100%"
                    autocomplete
                    @input-change="searchDropdown($event, pickers)"
                >
                    <vs-select-item v-for="(item, index) in pickers.data" :key="index" :value="item.id" :text="item.username"/>
                </vs-select>

                <label class="vs-input--label">Add {{ confirm_length }} order(s) to wavepick?</label>     
            </div>
        </vs-prompt>
    </div>
</template>

<script>
import { AgGridVue } from "ag-grid-vue"
import '@/assets/scss/vuesax/extraComponents/agGridStyleOverride.scss'
import vSelect from 'vue-select'
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import { VueContext } from 'vue-context';

export default {
    components: {
        vSelect,
        AgGridVue,
        flatPickr,
        VueContext
    },
    data() {
        return {
            filterCount: 0,
            disableAdd: true,
            gridOptions: {},
            gridApi: null,
            columnDefs: null,
            defaultColDef: {
                sortable: true,
                editable: false,
                resizable: true,
                suppressMenu: true
            },
            selectedId: null,
            isLoading: false,
            outbound: {
                data: [],
                current: 1,
                from: 0,
                to: 0,
                total: 0,
                pages: 1,
                filter: {
                    show: false,
                    outbound_reference: '',
                    client_id: null,
                    req_del_date_start: null,
                    req_del_date_end: null,
                    origin_id: null,
                    destination_id: null,
                    status_id: 1,
                    type: 'single',
                    order_source_id: null,
                    transporter_id: null,
                    service_type_id: null,
                    order_type_id: null
                }
            },
            ddl_client: {
                data: [],
                loading: false,
                endpoint: 'master/clients',
                objectKey: 'client_code'
            },
            ddl_origin: {
                data: [],
                loading: false,
                endpoint: 'master/customers',
                objectKey: 'name'
            },
            ddl_destination: {
                data: [],
                loading: false,
                endpoint: 'master/customers',
                objectKey: 'name'
            },
            order_source: {
                data: [],
            },
            order_type: {
                data: [],
                loading: false,
                endpoint: 'master/order_types',
                objectKey: 'order_type'
            },
            service_type: {
                data: [],
                loading: false,
                endpoint: 'master/servicetypes',
                objectKey: 'service_type'
            },
            transporter: {
                data: [],
                loading: false,
                endpoint: 'master/transporters',
                objectKey: 'transporter_code'
            },
            confirm_assign: false,
            confirm_length:"",
            picker_id: null,
            pickers: [],
        }
    },
    watch: {
        isLoading: function(){
            if(this.isLoading){
                this.$vs.loading()
            }
            else{
                this.$vs.loading.close()
            }
        },
        'outbound.current': function() {
            this.fetch('order');
        }
    },
    methods: {
        fetch(type) {
            this.isLoading = true;
            if(type === 'wavepick') {
                return this.$http.post('wavepick/list', this.wavePick.filter)
                .then(res => {
                    this.wavePick.data = res.data.data;
                    this.wavePick.total = res.data.total;
                    this.wavePick.to = res.data.to || 0;
                    this.wavePick.from = res.data.from || 0;
                    this.wavePick.pages = res.data.last_page;
                    this.isLoading = false;
                })
                .catch(error => this.handleError(error));
            }
            else {
                return this.$http.post(`wavepick/order?page=${this.outbound.current}`, this.outbound.filter)
                .then(res => {
                    this.outbound.data = res.data.data;
                    this.outbound.total = res.data.total;
                    this.outbound.to = res.data.to || 0;
                    this.outbound.from = res.data.from || 0;
                    this.outbound.pages = res.data.last_page;
                    this.disableAdd = true;
                    this.isLoading = false;
                })
                .catch(error => this.handleError(error));
            }
        },
        createWavepick() {
            const id = this.$_.map(this.gridApi.getSelectedRows(), 'id');

            this.confirm_length = id.length
            this.confirm_assign = true
        },
        saveWavePick(){
            const id = this.$_.map(this.gridApi.getSelectedRows(), 'id');

            this.isLoading = true;
            this.$http.post('wavepick/create', {
                orders: id,
                picker: this.picker_id
            })
            .then(res => {
                this.$vs.notify({
                    color: "success",
                    title: "Success",
                    iconPack: "feather",
                    icon: "icon-check",
                    text: res.data.message || 'Created successfully.'
                });

                this.$router.push({
                    name: 'wave-pick-planning-view',
                    params: {
                        id: res.data.id
                    }
                });
            })
            .catch(error => this.handleError(error))
        },
        filterInit() {
            if(this.filterCount < 1) {
                this.isLoading = true
                this.fetchDropdowns()
                .then(() => {
                    this.isLoading = false
                    this.outbound.filter.show = true
                    this.filterCount++
                })
                .catch(error => this.handleError(error))
            }
            else {
                this.outbound.filter.show = true
            }
        },
        fetchDropdowns() {
            return Promise.all([
                this.$http.post("/master/clients"),
                this.$http.post("/master/customers"),
                this.$http.post("/master/ordertypes"),
                this.$http.get("/master/ordersources"),
                this.$http.post("/master/transporters"),
                this.$http.post("/master/servicetypes"),
            ])
            .then(
                this.$http.spread((clients, customers, order_types, order_sources, transporters, service_types) => {
                    this.ddl_client.data = clients.data.data;
                    this.ddl_origin.data = customers.data.data;
                    this.ddl_destination.data = customers.data.data;
                    this.order_type.data = order_types.data.data;
                    this.order_source.data = order_sources.data;
                    this.transporter.data = transporters.data.data;
                    this.service_type.data = service_types.data.data;

                    this.ddl_origin.data.unshift({
                        id: null,
                        name: 'Any'
                    })

                    this.ddl_client.data.unshift({
                        id: null,
                        client_code: 'Any'
                    })

                    this.order_source.data.unshift({
                        id: null,
                        name: 'Any'
                    });

                    this.transporter.data.unshift({
                        id: null,
                        transporter_code: 'Any'
                    });

                    this.service_type.data.unshift({
                        id: null,
                        service_type: 'Any'
                    });

                    this.order_type.data.unshift({
                        id: null,
                        order_type: 'Any'
                    });
                })
            );
        },
        fetchPicker(){
            Promise.all([
                this.$http.post("rolemanagement/users"),
            ])
            .then(this.$http.spread((user) => {
                this.pickers.data = user.data.data
                this.$vs.loading.close();
            }))
            .catch(error => {
                this.isLoading = false
                this.$vs.dialog({
                    type: 'confirm',
                    color: 'danger',
                    title: 'Server Error',
                    text: 'Try again?',
                    accept: () => {
                        this.fetchPicker()
                    },
                    cancel: () => this.$router.push({name: 'movement-order'}),
                    acceptText: 'Yes',
                    cancelText: 'No'
                })
            })
        },
    },
    mounted() {
        Promise.all([
            this.fetch('order')
        ])
        .then(() => this.isLoading = false);
        this.gridApi = this.gridOptions.api
        this.fetchPicker()
    },
    beforeMount() {
        this.columnDefs = [
            {
                headerName: 'ID',
                field: 'id',
                width: 120,
                checkboxSelection: true,
                headerCheckboxSelection: true
            },
            {
                headerName: 'Client ID',
                field: 'client_code',
                width: 120,
            },
            {
                headerName: 'Reference',
                width: 120,
                field: 'outbound_reference',
            },
            {
                headerName: 'Req. Del. Date',
                field: 'req_del_date',
                width: 120,
            },
            {
                headerName: 'Origin Name',
                field: 'origin_name',
                width: 120,
            },
            {
                headerName: 'Origin Address',
                field: 'origin_address',
                width: 120,
            },
            {
                headerName: 'Origin Area',
                field: 'origin_area',
                width: 120,
            },
            {
                headerName: 'Destination Name',
                field: 'destination_name',
                width: 120,
            },
            {
                headerName: 'Destination Address',
                field: 'destination_address',
                width: 120,
            },
            {
                headerName: 'Destination Area',
                field: 'destination_area',
                width: 120,
            },
            {
                headerName: 'Status',
                field: 'status',
                width: 120,
            },
        ];
    },
    beforeRouteLeave(to, from, next) {
        this.outbound.filter.show = false;
        setTimeout(() => {
            next();
        }, 100);
    }
}

</script>